"use client";

import { InventoryIcon, MusicLibraryIcon, ReleaseIcon } from "@/components/appIcons";
import type { AppIcon } from "@/components/appIcons";

interface DiscographyEmptyStateProps {
  icon: AppIcon;
  title: string;
  description: string;
}

export function DiscographyEmptyState({ icon, title, description }: DiscographyEmptyStateProps) {
  const Icon = icon;

  return (
    <div className="relative overflow-hidden rounded-lg border border-dashed border-border bg-secondary/30 px-5 py-8 text-center sm:px-8 sm:py-9">
      <div className="pointer-events-none absolute inset-x-8 top-0 h-px bg-gradient-to-r from-transparent via-primary/45 to-transparent" />

      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-primary/25 bg-primary/10 text-primary shadow-[0_0_32px_rgba(238,103,55,0.12)]">
        <Icon className="text-[30px]" />
      </div>

      <div className="mx-auto mt-4 max-w-xl">
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        <p className="mt-2 text-sm leading-6 text-muted-foreground">{description}</p>
      </div>

      <div
        className="mt-5 flex items-center justify-center gap-2 text-muted-foreground/55"
        aria-hidden="true"
      >
        <ReleaseIcon className="rounded-full border border-border bg-background/40 p-2 text-[18px]" />
        <MusicLibraryIcon className="rounded-full border border-border bg-background/40 p-2 text-[18px]" />
        <InventoryIcon className="rounded-full border border-border bg-background/40 p-2 text-[18px]" />
      </div>
    </div>
  );
}
